import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { createRoutingURI } from '@scripts/utils/domain';
import CookieBanner from 'ech-components/src/components/CookieBanner';
import { useNavigationQuery } from '@queries/useNavigationQuery';

const EchCookieBanner = () => {
  const intl = useIntl();
  const [isClient, setIsClient] = useState(false);
  const { nodes } = useNavigationQuery();
  const { legalText } = nodes.filter(
    (node: { node_locale: string }) => node.node_locale == intl.locale,
  )[0];

  const mainTitle = intl.formatMessage({
    id: 'page.cookieBanner.mainTitle',
  });
  const mainText = intl.formatMessage({
    id: 'page.cookieBanner.mainText',
  });
  const settingsTitle = intl.formatMessage({
    id: 'page.cookieBanner.settingsTitle',
  });
  const settingsText = intl.formatMessage({
    id: 'page.cookieBanner.settingsText',
  });
  const openSettings = intl.formatMessage({
    id: 'page.cookieBanner.openSettings',
  });
  const saveSettings = intl.formatMessage({
    id: 'page.cookieBanner.saveSettings',
  });
  const acceptAll = intl.formatMessage({
    id: 'page.cookieBanner.acceptAll',
  });
  const functionalTitle = intl.formatMessage({
    id: 'page.cookieBanner.functionalTitle',
  });
  const functionalText = intl.formatMessage({
    id: 'page.cookieBanner.functionalText',
  });
  const analyticsTitle = intl.formatMessage({
    id: 'page.cookieBanner.analyticsTitle',
  });
  const analyticsText = intl.formatMessage({
    id: 'page.cookieBanner.analyticsText',
  });
  const marketingTitle = intl.formatMessage({
    id: 'page.cookieBanner.marketingTitle',
  });
  const marketingText = intl.formatMessage({
    id: 'page.cookieBanner.marketingText',
  });

  const linkOne = {
    href: createRoutingURI({
      root: '',
      slug: legalText[1].slug,
      locale: intl.locale,
    }),
    title: legalText[1].navigationTitle,
  };
  const linkTwo = {
    href: createRoutingURI({
      root: '',
      slug: legalText[0].slug,
      locale: intl.locale,
    }),
    title: legalText[0].navigationTitle,
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    isClient && (
      <CookieBanner
        labels={{
          mainTitle,
          mainText,
          settingsTitle,
          settingsText,
          openSettings,
          saveSettings,
          acceptAll,
          functionalTitle,
          functionalText,
          analyticsTitle,
          analyticsText,
          marketingTitle,
          marketingText,
        }}
        links={{ linkOne, linkTwo }}
      />
    )
  );
};

export default EchCookieBanner;
